import React from 'react';
import type { IntercomAlignment } from './service';

export interface IntercomContextProps {
  hide: () => void;
  show: (message?: string) => void;
  boot: (alignment?: IntercomAlignment) => Promise<void>;
  shutdown: () => void;

  /**
   * Show the default launcher icon
   */
  showLauncher: (alignment?: IntercomAlignment) => void;

  /**
   * Hide the default launcher icon
   */
  hideLauncher: () => void;
  startSurvey: (id: string) => void;

  /**
   * Identify the current user for Intercom
   */
  identify: (idProps: { userId?: string; email?: string; name?: string }) => void;
}

export const IntercomContext = React.createContext<IntercomContextProps>({
  hide: () => {
    throw Error('No Intercom Provider');
  },
  show: () => {
    throw Error('No Intercom Provider');
  },
  boot: () => {
    throw Error('No Intercom Provider');
  },
  shutdown: () => {
    throw Error('No Intercom Provider');
  },
  hideLauncher: () => {
    throw Error('No Intercom Provider');
  },
  showLauncher: () => {
    throw Error('No Intercom Provider');
  },
  startSurvey: () => {
    throw Error('No Intercom Provider');
  },
  identify: () => {
    throw Error('No Intercom Provider');
  },
});
